// Shared motion tokens. Keep values here so timing stays consistent across
// sections — tuning one curve should not mean editing thirteen files.

/** Strong ease-out. Entrances and exits. Mirrors --ease-out in index.css. */
export const EASE = [0.22, 1, 0.36, 1];

/** Ultra-responsive ease-out-expo for crisp, delay-free UI state feedback */
export const EASE_EXPO = [0.16, 1, 0.3, 1];

/** Subtle elastic overshoot curve for interactive micro-pops */
export const EASE_BACK = [0.34, 1.56, 0.64, 1];

/** Organic spring physics token for tactile button taps and pop-ins */
export const SPRING_TACTILE = {
  type: "spring",
  stiffness: 420,
  damping: 26,
  mass: 0.8,
};

/** Standard viewport trigger for scroll reveals. */
export const VIEWPORT = { once: true, margin: "-40px" };

/**
 * Scroll-reveal preset. Sub-400ms travel — snappy and polished without reading
 * as page loading lag.
 */
export const reveal = (delay = 0, { y = 16, duration = 0.38 } = {}) => ({
  initial: { opacity: 0, y },
  whileInView: { opacity: 1, y: 0 },
  viewport: VIEWPORT,
  transition: { duration, delay, ease: EASE_EXPO },
});

/** True when the user has asked the OS for less motion. */
export const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
